export default __webpack_public_path__ + "static/media/hacksaw-gaming.bd18190f.webp";